import styled from 'styled-components';
import StyledHeader from './StyledHeader';
import StyledList from './StyledList';
import StyledContainer from './StyledContainer';
import StyledLoading from './StyledLoading';

const ToggleHiddenLogsStyles = (Component) => styled(Component)`
  font-weight: normal;
  border-radius: 2px;
  width: 32px;
  height: 32px;
  border: 1px solid var(--primary500);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
  margin-left: 8px;

  &&:hover {
    cursor: pointer;
    background-color: var(--primary100);
  }
`;

export { StyledHeader, StyledList, StyledContainer, StyledLoading, ToggleHiddenLogsStyles };
